document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.multicolumn-card__title--collapsible').forEach(function (btn) {
    btn.addEventListener('click', function () {
      const expanded = btn.getAttribute('aria-expanded') === 'true';
      btn.setAttribute('aria-expanded', !expanded);
      const text = document.getElementById(btn.getAttribute('aria-controls'));
      if (text) {
        if (expanded) {
          text.setAttribute('hidden', '');
        } else {
          text.removeAttribute('hidden');
        }
      }
    });
  });
});
